import React from "react";
import ReactDOM from "react-dom/client";
import Home from "./page";
import "./theme.css";
import "./globals.css";
import "./vector.css";
import "./marketing.css";
import "./product.css";
import "./history.css";
import "./design-agent.css";
import "./showcase.css";
import "./design-only.css";
const root = document.getElementById("root")!;
const app = (
  <React.StrictMode>
    <Home />
  </React.StrictMode>
);
if (root.hasChildNodes()) ReactDOM.hydrateRoot(root, app);
else ReactDOM.createRoot(root).render(app);
